import { useMemo } from "react";
import { Button, Modal } from "react-bootstrap";
import ClocksData from "./clocks/ClocksData";
import { useResolvedModules } from "./HelperHooks";

export default function ClocksModal({ show, handleClose, radioId, date, hour, addToCollectionAllowed, startAudioTime = 0 }) {
    const resolvedModules = useResolvedModules();

    const clocksEnabled = useMemo(() => resolvedModules?.includes(1), [resolvedModules]);

    return (
        <Modal centered show={show && clocksEnabled} onHide={handleClose} className="clocks-modal">
            <Modal.Body>
                <ClocksData
                    radioId={radioId}
                    demo={[]}
                    secondary
                    date={date}
                    hour={hour}
                    addToCollectionAllowed={addToCollectionAllowed}
                    startAudioTime={startAudioTime}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button variant="ra-yellow" size="sm" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
